import { Http } from '@mygpt/app/http';
import { correctTTSPronunciation } from '@mygpt/app/speech/utils/ttsPronunciation';
import { requireSharedIntegration } from '@mygpt/app/config/integrations';

export type MSTokenInfo = {
  STTToken: string;
};

// 获取MS STT用Token
export const getMSTokenInfo = () => {
  const { get } = Http.use();
  return get<string>(`/v1/stt_token`).then((res) => ({
    STTToken: res.data,
  }));
};

export const getTTS = async (text: string, lang?: string, voice_actor?: string) => {
  requireSharedIntegration('Text to speech');
  // TTS服务语言映射：en, ja, zh, ko以外的语言都传multi
  const ttsLang = lang && ['en', 'ja', 'zh', 'ko'].includes(lang) ? lang : 'multi';

  // 语音合成前修正专有名词读法（仅影响送往 TTS 的文本，不影响画面显示）
  const spokenText = correctTTSPronunciation(text);

  const res = await fetch('https://tts.gbase.ai/tts', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'audio/wav',
    },
    body: JSON.stringify({
      text: spokenText,
      ...(lang ? { lang: ttsLang } : {}), //中文 (zh) 英文 (en) 日语 (ja) 韩语 (ko) 其他 (multi)
      ...(voice_actor ? { voice_actor } : {}), // 语音角色
    }),
  });

  return res.blob();
};

export const getQuestionLang = async (text: string) => {
  requireSharedIntegration('Language detection');
  const res = await fetch('https://tts.gbase.ai/detect-language', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      text,
    }),
  });

  const data = await res.json();
  return data.language;
};
